module.exports = __webpack_public_path__ + "assets/column-1.3bb67b5b.svg";